module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point01_04_travel-897c493af7f31b263884fa0706a731da.jpg";